import {BaseMobxStore} from "../../infrastructure/mobx/base-mobx-store";
import {FilterBarModuleConfig} from "./filter-bar-module.config";
import {FilterBarModuleState} from "./models/filter-bar-module.state";

export class FilterBarModuleStore extends BaseMobxStore {
  static injectables = [FilterBarModuleConfig, FilterBarModuleState];
}

